import { ReactNode } from 'react';
import { JSONContent } from '@tiptap/core';

import { getTextFromRichtext } from 'approot/shared/logic/get-text-from-richtext';
import * as Styled from './activity-builder-intro.style';
import IconGoogleTranslate from 'approot/shared/icons/icon-google-translate';

export const ActivityBuilderIntroTitle = ({
  title,
  richtext,
  logo,
}: {
  title?: string;
  richtext?: JSONContent | null;
  logo?: ReactNode;
}) => {
  const content =
    title ||
    getTextFromRichtext({
      richtext,
      sourceFile: 'activity-builder-intro.tsx',
    });

  if (!content) return null;

  return (
    <Styled.IntroTextWrapper>
      <Styled.IntroTitle
        data-selector="intro-title"
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
      {logo}
    </Styled.IntroTextWrapper>
  );
};

export const ActivityBuilderIntroTitlePrint = ({
  richtext,
  logo,
}: {
  richtext?: JSONContent | null;
  logo?: ReactNode;
}) => {
  const content = getTextFromRichtext({
    richtext,
    sourceFile: 'activity-builder-intro.tsx',
  });
  return (
    <Styled.IntroTextWrapperPrint>
      <Styled.IntroTitle
        data-selector="intro-title"
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
      {logo}
    </Styled.IntroTextWrapperPrint>
  );
};

export const inquisitiveLogoSvg = (
  <svg version="1.1" viewBox="0 0 135 30" xmlns="http://www.w3.org/2000/svg">
    <linearGradient
      id="inquisitiveLogoGradient"
      x1="100%"
      x2="0%"
      y1="46.664%"
      y2="46.664%"
    >
      <stop stopColor="#8493c9" offset="0" />
      <stop stopColor="#9e8bca" offset=".50272" />
      <stop stopColor="#ad88b9" offset="1" />
    </linearGradient>
    <path
      d="m99.1 0a2.946 2.946 0 1 0 0 5.891 2.946 2.946 0 0 0 0-5.891zm-19.244 0a2.946 2.946 0 1 0 .001 5.893 2.946 2.946 0 0 0 0-5.893zm-20.941 0a2.946 2.946 0 1 0 -.001 5.892 2.946 2.946 0 0 0 .001-5.892zm-55.97 0a2.946 2.946 0 1 0 0 5.891 2.946 2.946 0 0 0 0-5.891zm84.522 4.527v4.541h-3.293v3.698h3.293v11.787h4.023v-11.787h3.292v-3.698h-3.292v-4.541zm32.108 12.253c0-4.51 3.54-8.18 7.886-8.18 4.347 0 7.688 3.67 7.688 8.18 0 .427-.032.847-.094 1.258l-11.567.006c.47 1.993 2.03 3.458 3.975 3.458 1.172 0 2.236-.532 3.005-1.392h4.193c-1.234 2.855-3.996 4.85-7.2 4.85-4.347 0-7.886-3.67-7.886-8.18zm7.888-4.722c-1.71 0-3.12 1.13-3.756 2.755h7.448c-.613-1.625-1.983-2.755-3.692-2.755zm-64.26 1.589c0 2.162 1.405 3.948 4.512 4.606l2.126.47c1.242.25 1.732.814 1.732 1.504 0 .816-.685 1.536-2.125 1.536-1.896 0-2.845-1.128-2.943-2.35h-3.727c0 2.073 1.864 5.547 6.702 5.547 4.218 0 6.246-2.57 6.246-5.078 0-2.256-1.602-4.104-4.773-4.73l-2.289-.472c-.884-.157-1.47-.626-1.47-1.378 0-.877.914-1.536 2.058-1.536 1.83 0 2.517 1.16 2.649 2.069h3.63c0-1.99-1.733-5.234-6.312-5.234-3.466 0-6.016 2.287-6.016 5.046zm-40.378 3.133c0-4.51 3.537-8.18 7.885-8.18a7.36 7.36 0 0 1 3.874 1.09v-.622h4.043v20.932h-4.043v-6.1a7.49 7.49 0 0 1 -3.933 1.12c-3.635 0-6.697-2.616-7.563-6.144a8.47 8.47 0 0 1 -.263-2.096zm4.073.06c0 2.308 1.625 4.187 3.759 4.187 2.133 0 3.87-1.879 3.87-4.188 0-2.307-1.737-4.187-3.87-4.187-2.134 0-3.759 1.88-3.759 4.187zm-19.635-2.129v9.84h4.17v-9.12c0-2.187 1.504-3.07 2.7-3.07 1.195 0 2.7.883 2.7 3.07v9.12h4.168v-9.84c0-3.386-3.045-6.111-6.869-6.111s-6.869 2.725-6.869 6.11zm108.012-5.644h4.572l-6.332 15.485h-4.198l-6.33-15.485h4.571l3.859 10.317zm-18.26 15.485h4.168v-15.484h-4.168v15.485zm-19.241 0h4.168v-15.484h-4.168v15.485zm-20.944 0h4.17v-15.484h-4.17v15.485zm-6.4-15.484v9.119c0 2.186-1.506 3.071-2.7 3.071-1.196 0-2.701-.885-2.701-3.071v-9.119h-4.17v9.84c0 3.384 3.047 6.112 6.87 6.112 3.825 0 6.87-2.728 6.87-6.112v-9.84h-4.17zm-49.568 15.485h4.168v-15.485h-4.17v15.485z"
      fill="url(#inquisitiveLogoGradient)"
      fillRule="evenodd"
    />
  </svg>
);

export const ActivityBuilderIntroHeader = ({
  unitName,
  contentName,
  contentLabel = 'Lesson',
}: {
  unitName: string;
  contentName: string;
  contentLabel?: string;
}) => {
  return (
    <Styled.IntroHeader>
      {inquisitiveLogoSvg}
      <Styled.IntroHeaderMeta>
        <Styled.IntroHeaderMetaContent>
          <Styled.IntroHeaderPill>
            Unit <strong>{unitName}</strong>
          </Styled.IntroHeaderPill>
          <Styled.IntroHeaderPill>
            {contentLabel} <strong>{contentName}</strong>
          </Styled.IntroHeaderPill>
        </Styled.IntroHeaderMetaContent>
      </Styled.IntroHeaderMeta>
    </Styled.IntroHeader>
  );
};

export const ActivityBuilderIntroFooter = ({
  subject,
  pageNumber,
  showGoogleAttribution,
}: {
  subject: string;
  pageNumber: number;
  showGoogleAttribution?: boolean;
}) => {
  return (
    <Styled.IntroFooter>
      <Styled.IntroHeaderMeta>
        <Styled.IntroHeaderMetaContent>
          <Styled.IntroFooterSubject>{subject}</Styled.IntroFooterSubject>
          {showGoogleAttribution && (
            <Styled.IntroFooterAttribution>
              <IconGoogleTranslate width={122} height={16} />
            </Styled.IntroFooterAttribution>
          )}
          <Styled.IntroFooterPageWrapper>
            {inquisitiveLogoSvg}
            <Styled.IntroFooterPageNumber>
              {pageNumber}
            </Styled.IntroFooterPageNumber>
          </Styled.IntroFooterPageWrapper>
        </Styled.IntroHeaderMetaContent>
      </Styled.IntroHeaderMeta>
    </Styled.IntroFooter>
  );
};

export const IntroPresentStart = ({ onStart }: { onStart: () => void }) => (
  <Styled.IntroStartWrapper>
    <Styled.IntroStartButton type="button" onClick={onStart}>
      Get Started
    </Styled.IntroStartButton>
  </Styled.IntroStartWrapper>
);

export const IntroPresentEditStart = () => (
  <Styled.IntroStartWrapper>
    <Styled.IntroStartButtonView />
  </Styled.IntroStartWrapper>
);
